window.SwymWishlist = window.SwymWishlist || {};

SwymWishlist.loadRecommendations = async function(products) {
  const recsContainer = document.getElementById('swym-wishlist-recommendations');
  if (!recsContainer || !products || products.length === 0) {
    if (recsContainer) recsContainer.style.display = 'none';
    return;
  }

  const firstProduct = products[0];
  if (!firstProduct || !firstProduct.du) {
    recsContainer.style.display = 'none';
    return;
  }

  const translations = SwymWishlist.translations || {};

  try {
    const productId = firstProduct.empi;
    if (!productId) {
      recsContainer.style.display = 'none';
      return;
    }

    const recsResponse = await fetch(SwymWishlist.getLocalizedPath(`/recommendations/products.json?product_id=${productId}&limit=6&intent=related`));
    if (!recsResponse.ok) {
      recsContainer.style.display = 'none';
      return;
    }

    const recsData = await recsResponse.json();
    const recommendedProducts = recsData.products;

    if (!recommendedProducts || recommendedProducts.length === 0) {
      recsContainer.style.display = 'none';
      return;
    }

    const arrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M12.175 9H0V7H12.175L6.575 1.4L8 0L16 8L8 16L6.575 14.6L12.175 9Z" fill="currentColor"/>
    </svg>`;

    let html = `
      <div class="swym-recommendations">
        <div class="swym-recommendations__header">
          <h2 class="swym-recommendations__title">
            <span>${translations.recommendations_line1 || 'Products'}</span>
            <span>${translations.recommendations_line2 || 'chosen'}</span>
            <span>${translations.recommendations_line3 || 'for you'}</span>
          </h2>
          <div class="swym-recommendations__nav swym-recommendations__nav--desktop">
            <button class="swym-recommendations__arrow swym-recommendations__arrow--prev" aria-label="Previous">
              ${arrowSvg}
            </button>
            <button class="swym-recommendations__arrow swym-recommendations__arrow--next" aria-label="Next">
              ${arrowSvg}
            </button>
          </div>
        </div>
        <div class="swiper swym-recommendations__swiper">
          <div class="swiper-wrapper">
    `;

    recommendedProducts.forEach(product => {
      const imageUrl = product.featured_image ? product.featured_image.replace(/\.([^.]+)$/, '_1000x.$1') : '';
      const price = SwymWishlist.formatMoney(product.price);
      const comparePrice = product.compare_at_price ? SwymWishlist.formatMoney(product.compare_at_price) : '';
      html += `
        <div class="swiper-slide">
          <div class="swym-wishlist__item swym-recommendations__item">
            <div class="swym-wishlist__item-media">
              <a href="/products/${product.handle}" class="swym-wishlist__item-link">
                ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" width="1000" height="1063" loading="lazy">` : ''}
              </a>
            </div>
            <div class="swym-wishlist__item-info">
              <h3 class="swym-wishlist__item-title">${product.title}</h3>
              <p class="swym-wishlist__item-price">
                ${comparePrice && comparePrice !== price ? `<span class="swym-wishlist__compare-price">${comparePrice}</span>` : ''}
                ${price}
              </p>
            </div>
          </div>
        </div>
      `;
    });

    html += `
          </div>
        </div>
        <div class="swym-recommendations__nav swym-recommendations__nav--mobile">
          <button class="swym-recommendations__arrow swym-recommendations__arrow--prev" aria-label="Previous">
            ${arrowSvg}
          </button>
          <button class="swym-recommendations__arrow swym-recommendations__arrow--next" aria-label="Next">
            ${arrowSvg}
          </button>
        </div>
      </div>
    `;
    if (SwymWishlist.recommendationsSwiper) {
      SwymWishlist.recommendationsSwiper.destroy(true, true);
      SwymWishlist.recommendationsSwiper = null;
    }

    recsContainer.innerHTML = html;
    recsContainer.style.display = 'block';

    if (typeof Swiper !== 'undefined') {
      const swiperContainer = recsContainer.querySelector('.swym-recommendations__swiper');
      const nextButtons = recsContainer.querySelectorAll('.swym-recommendations__arrow--next');
      const prevButtons = recsContainer.querySelectorAll('.swym-recommendations__arrow--prev');

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const slidesPerView = isMobile ? 1 : 3;
      const spaceBetween = isMobile ? 16 : 0;
      
      const initSwiper = () => {
        if (swiperContainer.offsetWidth === 0) {
          requestAnimationFrame(initSwiper);
          return;
        }
        
        SwymWishlist.recommendationsSwiper = new Swiper(swiperContainer, {
          slidesPerView: slidesPerView,
          spaceBetween: spaceBetween,
          grabCursor: true,
          speed: 450,
          loop: false,
          observer: true,
          observeParents: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: Array.from(nextButtons),
            prevEl: Array.from(prevButtons),
          },
          on: {
            resize: function() {
              const nowMobile = window.matchMedia('(max-width: 749px)').matches;
              this.params.slidesPerView = nowMobile ? 1 : 3;
              this.params.spaceBetween = nowMobile ? 16 : 0;
              this.update();
            }
          }
        });
      };
      
      requestAnimationFrame(initSwiper);
    }
  } catch (err) {
    recsContainer.style.display = 'none';
  }
};
